module.exports = __webpack_public_path__ + "img/icon-eoi-checked.af10df82.png";